module.exports = __webpack_public_path__ + "static/media/Phone-365.ebf73c92.svg";